export default "__VITE_ASSET__31c19a39__"